"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _awsLogo = _interopRequireDefault(require("../../images/aws-logo"));
var _googleCloudLogoNew = _interopRequireDefault(require("../../images/google-cloud-logo-new"));
var _azureLogo = _interopRequireDefault(require("../../images/azure-logo"));
var _redhatLogo = _interopRequireDefault(require("../../images/redhat-logo"));
var _tackleLogoSymbol = _interopRequireDefault(require("../../images/tackle-logo-symbol"));
var _stripeLogo = _interopRequireDefault(require("../../images/stripe-logo"));
var _slackLogo = _interopRequireDefault(require("../../images/integrations/slack-logo"));
var _marketoLogo = _interopRequireDefault(require("../../images/integrations/marketo-logo"));
var _postmarkLogo = _interopRequireDefault(require("../../images/integrations/postmark-logo"));
var _microsoftLogo = _interopRequireDefault(require("../../images/microsoft-logo"));
var _awsLightLogo = _interopRequireDefault(require("../../images/aws-light-logo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ProviderIcon = function ProviderIcon(_ref) {
  var _ref$provider = _ref.provider,
    provider = _ref$provider === void 0 ? null : _ref$provider,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'large' : _ref$fontSize,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light;
  switch (provider) {
    case 'aws':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, light ? /*#__PURE__*/_react.default.createElement(_awsLightLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }) : /*#__PURE__*/_react.default.createElement(_awsLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'gcp':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_googleCloudLogoNew.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'stripe':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_stripeLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'azure':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_azureLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'redhat':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_redhatLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'microsoft':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_microsoftLogo.default, {
        disabled: disabled,
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'slack':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_slackLogo.default, {
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'marketo':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_marketoLogo.default, {
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'tackle':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_tackleLogoSymbol.default, {
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    case 'postmark':
      return /*#__PURE__*/_react.default.createElement(_core.Icon, {
        fontSize: fontSize
      }, /*#__PURE__*/_react.default.createElement(_postmarkLogo.default, {
        style: {
          display: 'block'
        },
        height: "1em",
        width: "1em"
      }));
    default:
      return null;
  }
};
var _default = ProviderIcon;
exports.default = _default;